import React, {PureComponent} from "react";
import FilterBar from "./filterBar";
import { withRouter } from 'react-router-dom';
import { withActions, call, isBusy } from 'actionware';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import "./style.less";
import { Table } from "antd";
import { registrationTableColums } from "./metadata";
import { fetchLenderRegistrations } from "./actions";
import {getMessageID} from "../../utils/uuid";

@withRouter
@connect((state)=>{
  const { localize, lenderRegistrationPage } = state;
  return {
    translate: getTranslate(localize),
    lenderRegistrations : lenderRegistrationPage.registrations ?? [],
    loading: isBusy(fetchLenderRegistrations)
}})

@withActions({
  fetchLenderRegistrations
})

class LenderRegistrations extends PureComponent {
  
  fetchLenderRegistrations = (startDate, endDate) => {
    const msg_id = getMessageID();
    call(fetchLenderRegistrations, {start_date: startDate, end_date: endDate, msg_id});
  }
  getTableColumns = () => {
    if (!this.tableColumns || this.tableColumns.length === 0) {
      this.tableColumns = registrationTableColums.map((column) => {
        return {
          ...column,
          title: this.props.translate(column.title)
        };
      });
    }
    return this.tableColumns;
  }
  render() {
    const {translate, lenderRegistrations, loading} = this.props;
    return (
      <div className="lender-registrations">
        <FilterBar translate={translate} onSearch={this.fetchLenderRegistrations}/>
        <Table
          loading={loading} 
          columns={this.getTableColumns()}
          dataSource={lenderRegistrations}
        />
      </div>
    );
  }
}

export default LenderRegistrations;